var _path, _path2, _polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "circle",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "40.5px",
    height: "40.5px",
    viewBox: "0 0 40.5 40.5",
    enableBackground: "new 0 0 40.5 40.5",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fill: "#020202",
    d: "M40.5,20c0,11.046-7.971,20.5-19.5,20.5C9.47,40.5,0,31.046,0,20S9.346,0,20.876,0   C32.405,0,40.5,8.954,40.5,20z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fill: "#020202",
    d: "M40.5,20c0,11.046-7.971,20.5-19.5,20.5C9.47,40.5,0,31.046,0,20S9.346,0,20.876,0 C32.405,0,40.5,8.954,40.5,20z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "17.188,33.313 18.229,13.126 9.083,22.164 6.042,19.101 20.25,6.957 34.396,19.145 31.416,22.165 22.188,13.189 23.251,33.313 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.dda85681c3b37f1daa10ad73b897c3f3.svg";
export { ForwardRef as ReactComponent };